module.exports = __webpack_public_path__ + "static/media/Settings.5ab53afd.png";